'use client';
import { jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';
import { PopoverTrigger } from '../popover/popover-trigger.js';

/**
 * DropdownTrigger component, used within a Dropdown.TriggerContext to open a Dropdown.
 *
 * @example
 * <Dropdown.TriggerContext>
 *  <Dropdown.Trigger>Dropdown</Dropdown.Trigger>
 *  <Dropdown>
 *   <Dropdown.Heading>Heading</Dropdown.Heading>
 *    <Dropdown.List>
 *      <Dropdown.Item>
 *        <Dropdown.Button>Button</Dropdown.Button>
 *      </Dropdown.Item>
 *    </Dropdown.List>
 *  </Dropdown>
 * </Dropdown.TriggerContext>
 */
const DropdownTrigger = forwardRef(function DropdownTrigger({ asChild, ...rest }, ref) {
    return jsx(PopoverTrigger, { ref: ref, ...rest });
});

export { DropdownTrigger };
